export default function reducer(
  state = {
    autoCompleteDiscoverAudience: '',
  },
  action
) {
  switch (action.type) {
    case 'DISCOVER_AUDIENCE_AUTOCOMPLETE_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'DISCOVER_AUDIENCE_AUTOCOMPLETE_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        autoCompleteDiscoverAudience: action.payload,
      };
    }
    case 'DISCOVER_AUDIENCE_AUTOCOMPLETE_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        autoCompleteDiscoverAudience: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
